import { rgb2hex } from './Utils';

/* eslint-disable */

//#region jquery extensions

$.fn.changeElementType = function(newType) {
	var attrs = {};
	var element = this[0];
	if(element != undefined){
		$.each(element.attributes, function(idx, attr) {
			attrs[attr.nodeName] = attr.nodeValue;
		});
	}
	this.replaceWith(function() {
		return $("<" + newType + "/>", attrs).append($(this).contents());
	});
}


$.fn.pressEnter = function(fn) {  
	return this.each(function() {  
		$(this).bind('enterPress', fn);
		$(this).keyup(function (e) {
			if (e.keyCode == 13 || e.keyCode == 10) {
					$(this).trigger("enterPress");
            }
        })
    });  
}; 

$.fn.removeEmptyAnchorTags = function(fn) {  
	var anchors = $(this).find('a');
	$.each(anchors, function( index, value ) {
		if(!$(value).attr('href')){
			$(value).children('.unwrappable').unwrap();
		}
	});
}; 

$.fn.getHexBackgroundColor = function() {
    return (function(rgb) {
        return '#' + (!rgb ? 'FFFFFF' : rgb2hex(rgb))
    })($(this).css('background-color'));
}

//#endregion

//#region IE polyfills
if (!Array.prototype.includes) {
	Array.prototype.includes = function() {
		'use strict';
		return Array.prototype.indexOf.apply(this, arguments) !== -1;
	};
}

String.prototype.toBoolean = function() {
    var dictionary = { "True": true, "False": false, "true": true, "false": false };
    return dictionary[this];
}


Array.prototype.pushIfNotExists = function(element) { 
   if (!this.includes(element)) {
	   this.push(element);
   }
};

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
(function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('prepend')) {
        return;
      }
      Object.defineProperty(item, 'prepend', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function prepend() {
          var argArr = Array.prototype.slice.call(arguments),
            docFrag = document.createDocumentFragment();
          
          argArr.forEach(function (argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
          });
          
          this.insertBefore(docFrag, this.firstChild);
        }
      });
    });
  })([Element.prototype, Document.prototype, DocumentFragment.prototype]);


// https://gist.github.com/bob-lee/e7520bfcdac266e5490f40c2759cc955
if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
        }
    };
}

// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || 
                                Element.prototype.webkitMatchesSelector;
  }
  
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;
  
      do {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }

//#endregion